import updateCabinetVisualizer from './updateCabinetVisualizer';
import { saveCabinetDesign } from '../../../api/design';
import createAndUpdateDesign from './createAndUpdateDesign';
import {
  tryGetQueryParam
} from '../../../utils/queryParams';
import { NEW_RELIC_EVENTS } from '../../../constants';
import logNewRelicCustom from '../../../utils/logNewRelicCustom';

export default async (set, get, host, designId, designData) => {
  try {
    const userId = get().cabinetVisualizer.userId;
    const styleChoiceId = get().cabinetVisualizer.styleChoiceId;
    const currentStyleChoiceId = tryGetQueryParam('DesignStyleChoiceid');
    const hasCollectionSelected = currentStyleChoiceId !== null
      || (styleChoiceId && styleChoiceId.length > 0);
    const designHasProducts = designData.Products
      && designData.Products.length > 0
      && designData.Products.some((product) => product.Sku > 0);

    const existingDesign = get().cabinetVisualizer.designs[designId];

    if (existingDesign) {
      const updatedDesign = {
        ...existingDesign,
        ...designData,
        userId,
        ProductParentIds: {
          ...existingDesign.ProductParentIds,
          ...designData.ProductParentIds,
        }
      };

      // If this is the first action against the default design
      // Only send through create flow if there are products and a collection is selected
      if (designId.indexOf('temp-') === 0 && hasCollectionSelected && designHasProducts) {
        const createAndUpdateId = await createAndUpdateDesign(
          set, get, host, updatedDesign.DesignName, updatedDesign
        );
        set(
          createAndUpdateId,
          false,
          { type: 'cabinetVisualizer/updateDesignData' }
        );
        // NEWRELIC
        logNewRelicCustom(NEW_RELIC_EVENTS.CREATED_DESIGN, { createdDesignId: createAndUpdateId });
      } else {
        // Always update the temp wall in place if no products (do not remove from state)
        set(
          updateCabinetVisualizer(set, get, {
            designs: {
              ...get().cabinetVisualizer.designs,
              [designId]: updatedDesign
            }
          }),
          false,
          { type: 'cabinetVisualizer/updateDesignData' }
        );

        // Save the updated design to the server (if not temp, or if temp and has products)
        if (designId.indexOf('temp-') !== 0 || designHasProducts) {
          const response = await saveCabinetDesign(host, updatedDesign);

        }
      }
    } else {
      console.warn(`Design with ID: ${designId} not found in state.`);
    }
  } catch (err) {
    console.log(`Update Cabinet Design Error: ${err}`);
  }
};
